var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "nav nav-pills" }, [
    _c(
      "li",
      [
        _c(
          "router-link",
          {
            staticClass: "btn btn-dark",
            attrs: {
              tag: "a",
              to: {
                name: "managers.talent.index",
                params: { managerId: _vm.user.id },
              },
              exact: "",
            },
          },
          [
            _vm._v(
              "\n      Talent (" +
                _vm._s(_vm.user.management_talent_count) +
                ")\n    "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      [
        _c(
          "router-link",
          {
            staticClass: "btn btn-dark",
            attrs: {
              tag: "a",
              to: {
                name: "managers.requests.index",
                params: { managerId: _vm.user.id },
              },
              exact: "",
            },
          },
          [
            _vm._v(
              "\n      Requests (" +
                _vm._s(_vm.user.management_request_count) +
                ")\n    "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      [
        _c(
          "router-link",
          {
            staticClass: "btn btn-dark",
            attrs: {
              tag: "a",
              to: {
                name: "managers.bookings.index",
                params: { managerId: _vm.user.id },
              },
              exact: "",
            },
          },
          [
            _vm._v(
              "\n      Bookings (" +
                _vm._s(_vm.user.management_booking_count) +
                ")\n    "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }